<template>
  <div class="SummaryCoverages">
    <h2 class="gl_form-title">
      {{ answers.product?.productName }}
    </h2>

    <div
      v-for="(coverage, i) in filteredCoverages"
      :key="i"
      class="additional-coverage"
    >
      <InsuranceCardComponent
        :insured="coverage.title"
        :birthDate="coverage.date"
        :coverages="coverage.options"
      />
    </div>

    <TotalAmountComponent
      :key="price"
      :label="t('hiring.common.total-amount.total')"
      :amount="price"
      :currency="CURRENCY"
      :period="`/${period}`"
    />

    <BaseButton
      type="primary"
      @click="submit"
    >
      {{ t('copy_add-coverages-form_button-save') }}
    </BaseButton>
  </div>
</template>

<script lang="ts" setup>
  import { ref, onBeforeMount, computed } from 'vue'
  import InsuranceCardComponent from '@/modules/health/hiring/components/InsuranceCardComponent.vue'
  import TotalAmountComponent from '@/modules/common/hiring/components/TotalAmountComponent.vue'
  import BaseButton from '@/modules/core/components/ui/BaseButton.vue'

  import { useAdditionalCoveragesComposable } from '@/modules/core/composables/hiringAdditionalCoveragesComposable'
  import { useForeignHealthStore } from '../../stores'

  import type { CoverageInfoInterface } from '@/modules/core/models/types'
  import type AdditionalCoverageConfig from '@/modules/health/hiring/models/APP/AdditionalCoverageConfig'
  import { useI18n } from 'vue-i18n'
  import { CURRENCY } from '@/modules/common/common/constants/CommonConstants'
  import type ForeignHealthHiringAnswers from '../../models/APP/ForeignHealthHiringAnswers'

  const { t } = useI18n()

  const healthStore = useForeignHealthStore()

  interface PropsInterface {
    price: string
    answers: ForeignHealthHiringAnswers
    period: string
  }
  const props = withDefaults(defineProps<PropsInterface>(), {})

  const emit = defineEmits(['submit'])

  const { loadAdditionalCoverages } = useAdditionalCoveragesComposable(props.answers)

  const coveragesConfig = ref<AdditionalCoverageConfig[]>([])
  const additionalCoverages = ref<CoverageInfoInterface[]>([])

  const filteredCoverages = computed(() => {
    return additionalCoverages.value.filter((coverage) => coverage.options?.some((c) => c.checked))
  })

  function submit() {
    emit('submit')
  }

  function beforeMount() {
    coveragesConfig.value = healthStore.getAdditionalCoveragesConfig()
    additionalCoverages.value = loadAdditionalCoverages(
      coveragesConfig.value as AdditionalCoverageConfig[]
    )
  }

  onBeforeMount(beforeMount)
</script>

<style lang="scss" scoped>
  .SummaryCoverages {
    .InsuranceCardComponent {
      padding-bottom: $spacing-l;
      border-bottom: solid 1px $color-grey-border;
    }

    .additional-coverage:nth-last-of-type(2) {
      .InsuranceCardComponent {
        border: none;
        margin: 0;
      }
    }

    .TotalAmountComponent {
      border-top: solid 1px $color-primary;
      padding-top: $spacing-l;

      h2 {
        margin-bottom: $spacing-2xl;
      }
    }
  }
</style>
